export default function faq() {
    const faqList = document.querySelector('.faq__list');
    const viewAllBtn = document.getElementById('faqViewAll');
    const faqAsk = document.getElementById('faqAsk');

    if (faqList) {
        faqList.addEventListener('click', (e) => {
            const trigger = e.target.closest('.faq__trigger');
            
            if (!trigger) return;

            const currentItem = trigger.closest('.faq__item');
            const currentContent = currentItem.querySelector('.faq__content');
            const wrapper = currentContent.querySelector('.faq__answer-wrapper');
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

            // close other open items before toggling the current one
            const allItems = faqList.querySelectorAll('.faq__item');
            allItems.forEach(item => {
                if (item !== currentItem) {
                const otherTrigger = item.querySelector('.faq__trigger');
                const otherContent = item.querySelector('.faq__content');
                
                if (otherTrigger && otherContent) {
                    otherTrigger.setAttribute('aria-expanded', 'false');
                    otherContent.style.maxHeight = '0px';
                }
                }
            });

            // toggle the current accordion
            if (isExpanded) {
                trigger.setAttribute('aria-expanded', 'false');
                currentContent.style.maxHeight = '0px';
            } else {
                trigger.setAttribute('aria-expanded', 'true');
                currentContent.style.maxHeight = wrapper.offsetHeight + 'px';
            }
        });
    }

    // view all button logic
    if (viewAllBtn) {
        viewAllBtn.addEventListener('click', () => {
            const hiddenItems = document.querySelectorAll('.faq__item--hidden');
            hiddenItems.forEach(item => {
                item.classList.remove('faq__item--hidden');
                item.classList.add('faq__item--revealed');
            });
            viewAllBtn.parentElement.style.display = 'none';
        });
    }

    if (faqAsk) {
        faqAsk.addEventListener('click', (e) => {
            e.preventDefault();
            const CHAT_MODAL_HASH = '#open-ai-chat';
            window.location.hash = CHAT_MODAL_HASH;
        });
    }
}
